<template>
  <div>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          Kunder
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-text-field
          v-model="search"
          label="Søg"
          hide-details
          class="mr-4"
          autofocus
          solo
          placeholder="Skriv for at søge"
          dense
          clearable
        />

        <v-menu
          v-model="addMenu"
          left
          :close-on-content-click="false"
          min-width="500"
        >
          <template #activator="{ attrs, on }">
            <v-btn
              v-bind="attrs"
              v-on="on"
            >
              Tilføj
              <v-icon right> mdi-plus </v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              Ny kunde
            </v-card-title>

            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
              >
                <v-text-field
                  v-model="newItem.title"
                  label="Navn"
                  :rules="[ v => !!v || 'Udfyld et navn' ]"
                />
                <v-text-field
                  v-model="newItem.initials"
                  label="Initialer"
                  :rules="[ v => !!v || 'Udfyld initialer', v => String(v).length < 4 || 'Maks. 3 tegn' ]"
                />
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-btn
                text
                @click="clear"
              >
                {{ $t('common.cancel') }}
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                :disabled="!valid"
                @click="add"
              >
                Tilføj og rediger
                <v-icon right> mdi-plus </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-toolbar>

      <v-card-text>
        <v-data-table
          :items="customers"
          :headers="headers"
          :loading="loading"
          :sort-by="[ 'active', 'partDetailCount' ]"
          :sort-desc="[ true, true ]"
          :search.sync="search"
          multi-sort
          :items-per-page="-1"
        >
          <template #[`item.defaultLocale`]="{ item }">
            <span v-if="item.defaultLocale === 'en'">
              English
            </span>
            <span v-else-if="item.defaultLocale === 'da'">
              Dansk
            </span>
            <span v-else>
              {{ item.defaultLocale }}
            </span>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-btn icon :to="item.id" append>
              <v-icon> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Suppliers',
  data() {
    return {
      addMenu: false,
      creating: false,
      loading: false,
      headers: [
        { text: 'Name', value: 'title' },
        { text: 'Default language', value: 'defaultLocale' },
        { text: '', value: 'actions', sortable: false, align: 'end' }
      ],
      newItem: {
        title: '',
        initials: ''
      },
      customers: [],
      valid: false,
    }
  },
  computed: {
    search: {
      get() {
        return this.$route.query.search
      },
      set(value) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            search: value ?? undefined
          }
        })
      }
    }
  },
  async mounted() {
    this.fetchData();
  },
  methods: {
    async add() {
      this.creating = true;

      try {
        const { data } = await this.$api.post('customers', this.newItem);

        if (!data.success) {
          throw 'Error creating customer!';
        }

        this.$notifier.showSuccess({ message: 'Kunden blev tilføjet' });

        if (typeof data.model === 'string') {
          this.$router.push('/admin/customers/' + data.model);
        }
      } catch (error) {
        console.error(error);
        this.$notifier.showError({ message: 'Der skete en fejl. Prøv venligst igen.' });
      } finally {
        this.creating = false;
      }
    },
    clear() {
      this.addMenu = false;
      this.newItem = {
        title: '',
        aliases: []
      };
    },

    async fetchData() {
      try {
        this.loading = true;

        const { data } = await this.$api.get('customers');

        this.customers = data;
      } catch (error) {
        console.error(error);
        this.$notifier.showError({});
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
